import SubscriptionPlans from './SubscriptionPlans';

export default SubscriptionPlans;